// Route guard that redirects to the role's default route when the current
// role lacks access, and logs page views. Wraps routed scenes in the
// role-specific views.
import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { hasRouteAccess, getDefaultRouteForRole } from '../config/roleRoutes';
import logService from '../services/logService';

const RoleBasedRoute = ({ children, requiredRoute }) => {
  const { currentRole } = useAppContext();
  const location = useLocation();
  const lastLoggedPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== lastLoggedPath.current) {
      lastLoggedPath.current = currentPath;
      logService.pageViewed(currentPath);
    }
  }, [location.pathname]);

  if (!hasRouteAccess(currentRole, requiredRoute)) {
    return <Navigate to={getDefaultRouteForRole(currentRole)} replace />;
  }
  
  return children;
};

export default RoleBasedRoute;
